// vite supports "envs" in production by doing string
// replacements for all the envs in vite configs "define"
//
// this works fine, but it is nice to have them in the process
// object so that they can be inspected in the console. this
// takes care of that.
//
// when adding envs in the config they must be added here to
// in order to show up

Object.assign(window, {
  process: {
    env: {
      SERVER_BASE_URL: process.env.SERVER_BASE_URL || undefined,
      UI_URL: process.env.UI_URL || undefined,
      NODE_ENV: process.env.NODE_ENV,
      UPRIGHT_ENV: process.env.UPRIGHT_ENV,
      UI_VERSION: process.env.UI_VERSION,
      LOCAL_IP: process.env.LOCAL_IP,
      ENABLE_REACT_SCAN: process.env.ENABLE_REACT_SCAN,
      ENABLE_APPCUES: process.env.ENABLE_APPCUES,
      STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY,
    },
  },
});

export {};
